import { useEffect, useRef, useState } from "react";

// Animates a formatted number string (e.g. "₹6,99,04,572" or "14,22,700 kg") counting up from 0 on first render.
export function CountUp({ value, duration = 900, className = "", testid }) {
  const str = String(value ?? "");
  const m = str.match(/-?[\d,]+(\.\d+)?/);
  const target = m ? parseFloat(m[0].replace(/,/g, "")) : null;
  const decimals = m && m[1] ? m[1].length - 1 : 0;
  const [n, setN] = useState(0);
  const ran = useRef(false);
  useEffect(() => {
    if (target == null || ran.current || window.matchMedia("(prefers-reduced-motion: reduce)").matches) { setN(target); return; }
    ran.current = true;
    const t0 = performance.now();
    let raf;
    const tick = (t) => { const p = Math.min(1, (t - t0) / duration); const e = 1 - Math.pow(1 - p, 3); setN(target * e); if (p < 1) raf = requestAnimationFrame(tick); };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [target, duration]);
  if (target == null) return <span className={className} data-testid={testid}>{str}</span>;
  const shown = (n ?? target).toLocaleString("en-IN", { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
  return <span className={className} data-testid={testid}>{str.replace(m[0], shown)}</span>;
}
